"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { Progress } from "@/components/ui/progress";
function ReadingProgress() {
  const $ = _c(10);
  const [progress, setProgress] = useState(0);
  const [isStuck, setIsStuck] = useState(false);
  const sentinelRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = function handleScroll() {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? scrollTop / docHeight * 100 : 0;
        setProgress(Math.min(100, Math.max(0, scrollPercent)));
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const sentinel = sentinelRef.current;
      if (!sentinel) {
        return;
      }
      const observer = new IntersectionObserver(t4 => {
        const [entry] = t4;
        setIsStuck(!entry.isIntersecting);
      }, {
        threshold: 0
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div ref={sentinelRef} className="h-0 w-full" aria-hidden={true} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isStuck ? 1 : 0;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      opacity: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== progress || $[8] !== t6) {
    t7 = <>{t4}<Progress value={progress} className="sticky top-0 z-50 -mx-4 -mt-12 -mb-6 gap-0 transition-opacity duration-300 md:mx-0" style={t6} /></>;
    $[7] = progress;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
export { ReadingProgress };